(function() {

  initSlider();

  function initSlider(){
      var elem = document.querySelectorAll('.recipe-recommendations  .carousel');
      // elem.classList.remove('is-hidden');

      elem.forEach( function(elem){
              console.log(elem);
      elem.offsetHeight;
      var flkty = new Flickity( elem, {
      // options
      cellSelector: '.carousel__item',
      contain: false,
      groupCells: "100%",
      imagesLoaded: true,
      on: {
        ready: checkSliderAlone,
        resize: checkSliderAlone
        }
      });
    });
  }


  function checkSliderAlone(){
            if ( this.slides.length) {
                    this.slides.length < 2
                    ? this.element.classList.add('flickity-is-single')
                    : this.element.classList.remove('flickity-is-single')
            }
  }
    
}());
  